// src/pages/login/index.js
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { useAuth } from '../../components/AuthContext';
import { FaUser, FaEye, FaEyeSlash } from "react-icons/fa";
import { NotificationManager } from 'react-notifications';
import { loginUserAsync, logout } from '../../redux/slice/auth/authSlice';
import Appconfig from '../../config/config'
import { getUserBalanceAsync } from '../../redux/slice/user/userSlice'
import Loader from 'components/loader';

const Login = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { login, isAuthenticated } = useAuth();
    const [isLoading, setIsLoading] = useState(false)
    const [loginCredentials, setLoginCredentials] = useState({
        user_name: '',
        password: ''
    });
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const [rememberMe, setRememberMe] = useState(false);
    const { userBalance } = useSelector((state) => state.userbal);
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setLoginCredentials(prev => ({
            ...prev,
            [name]: value
        }));
    };


    const handleLogin = async (e) => {
        e.preventDefault();
        setIsLoading(true)
        if (!loginCredentials.user_name || !loginCredentials.password) {
            NotificationManager.error('Please enter both User ID and Password', '', 1000);
            return;
        }
        try {
            const result = await dispatch(loginUserAsync({
                user_name: loginCredentials.user_name,
                password: loginCredentials.password,
                site_code: Appconfig.sitecodes,
            })).unwrap();
            dispatch(getUserBalanceAsync());
            NotificationManager.success('Login Successful', '', 1000);
            setIsLoading(false)
            setLoginCredentials({
                user_name: '',
                password: ''
            });
            if (result.userdata?.user_type !== 'User') {
                navigate('/dashboard');
            } else {
                navigate('/');
            }
        } catch (error) {
            setIsLoading(false)
            NotificationManager.error(error || 'Login failed. Please try again.', '', 1000);
        }
    };
    const handleLogout = (item) => {
        if (item.isLogout) {
            dispatch(logout());
            navigate('/');
        }
    };


    return (
        <>
            {
                isLoading && <Loader />
            }
            <div className='absolute w-full left-0 top-0'>
                <div className='relative w-full flex items-center justify-center h-screen overflow-hidden bg-[linear-gradient(#022c43,_#18b0c8)] z-[999]'>
                    <div className='flex bg-[linear-gradient(#022c43,_#18b0c8)] absolute left-[10px] lg:left-[calc(50%-270px)] w-[94vw] lg:w-[540px] h-[408px] rounded-[8px] [box-shadow:0_5px_20px_#00000080]'>
                        <div className='flex flex-col items-center justify-center w-full'>
                            <img
                                className='align-middle border-none h-[70px] my-[25px] lg:mt-[0px] w-[140px] lg:w-[140px] mb-[15px]'
                                src='/assets/logo/logo.webp'
                                alt="Logo"
                            />
                            <form
                                method="post"
                                onSubmit={handleLogin}
                                autoComplete="off"
                                noValidate
                                className='w-full lg:w-[250px] px-[18px]'
                            >
                                {/* Username Input */}
                                <div className='mb-[1rem] lg:mb-[.7rem]'>
                                    <div className='relative bg-[white] h-[40px] lg:h-[33px] rounded-[5px] flex items-center'>
                                        <input
                                            value={loginCredentials.user_name}
                                            onChange={handleInputChange}
                                            className='bg-white outline-none lg:h-[33px] text-black border-transparent block w-full px-3 py-2 text-base font-normal leading-normal appearance-none rounded-md transition-border-color duration-150 ease-in-out transition-box-shadow duration-150 ease-in-out'
                                            type="text"
                                            autoFocus
                                            tabIndex="1"
                                            name="user_name"
                                            id="loginName"
                                            placeholder="Username"
                                            maxLength={30}
                                        />
                                        <button type='button' className='text-[black] text-[1rem] pl-3 pr-3 pt-[.375rem] pb-[.375rem]'>
                                            <FaUser />
                                        </button>
                                    </div>
                                    {/* {touched.user_name && validationErrors.user_name && (
                                        <span className="text-[0.813rem] text-red-500 leading-[14px]">
                                            <div className='leading-[14px] pt-[5px]'>{validationErrors.user_name}</div>
                                        </span>
                                    )} */}
                                </div>

                                {/* Password Input */}
                                <div className='mb-[1rem]'>
                                    <div className='relative bg-[white] h-[40px] lg:h-[33px] rounded-[5px] flex items-center'>
                                        <input
                                            value={loginCredentials.password}
                                            onChange={handleInputChange}
                                            // onBlur={handleBlur}
                                            className='bg-[white] lg:h-[33px] outline-none text-[black] border-transparent block w-full px-[.75rem] py-[.375rem] text-[1rem] font-normal leading-normal appearance-none rounded-[.375rem] [transition:border-color_.15s_ease-in-out,_box-shadow_.15s_ease-in-out]'
                                            type={showPassword ? 'text' : 'password'}
                                            tabIndex="2"
                                            minLength={6}
                                            id="password"
                                            name="password"
                                            placeholder="Password"
                                        />
                                        <button
                                            type='button'
                                            className='text-[black] text-[1rem] pl-3 pr-3 pt-[.375rem] pb-[.375rem]'
                                            onClick={togglePasswordVisibility}
                                        >
                                            {showPassword ? <FaEye /> : <FaEyeSlash />}
                                        </button>
                                    </div>
                                    {/* {touched.password && validationErrors.password && (
                                        <span className="text-[0.813rem] text-red-500 leading-[14px]">
                                            <div className='leading-[14px] pt-[5px]'>{validationErrors.password}</div>
                                        </span>
                                    )} */}
                                </div>

                                {/* Login Button */}
                                <div>
                                    <button
                                        type="submit"
                                        className="bg-[none_repeat_scroll_0_0_#6fe3f5] flex items-center justify-center bg-[linear-gradient(-180deg,_#6fe3f5,_#065265)] border-[1px] border-[solid] border-[#065265] [box-shadow:none] text-[#fff] rounded-[3px] float-right text-[16px] h-[40px] m-0 outline-[none] pt-[3px] px-[10px] pb-[5px] [text-shadow:0_1px_1px_rgba(0,_0,_0,_.5)] [transition:all_.2s_linear_0s] w-full normal-case"
                                        disabled={isLoading}
                                    >
                                        {isLoading ? 'Logging in...' : 'Login'}
                                        <svg
                                            className='ml-[5px]'
                                            width="10"
                                            height="11"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M5.71 7.706l1.432-1.604H1.778V4.898h5.39L5.71 3.294l.781-.86L9.278 5.5 6.49 8.565l-.78-.86zM1.12 0C.825 0 .564.124.339.372a1.24 1.24 0 0 0-.339.86v8.536c0 .325.113.611.339.86.225.248.486.372.78.372H8.88c.295 0 .556-.124.781-.372a1.24 1.24 0 0 0 .339-.86V7.333H8.88v2.435H1.12V1.232h7.76v2.435H10V1.232a1.24 1.24 0 0 0-.339-.86C9.436.124 9.175 0 8.881 0H1.12z"
                                                fill="currentColor"
                                                fillRule="evenodd"
                                            ></path>
                                        </svg>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Login;